import { render } from "./PackingListCarcassesModal.vue?vue&type=template&id=3a118407"
import script from "./PackingListCarcassesModal.vue?vue&type=script&lang=js"
export * from "./PackingListCarcassesModal.vue?vue&type=script&lang=js"

import "./PackingListCarcassesModal.vue?vue&type=style&index=0&id=3a118407&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__